<template>
  <div class="centerMe">
  <amplify-authenticator
    :authConfig="configurationOptions"

  >

    <div>

      <amplify-sign-out></amplify-sign-out>

    </div>

  </amplify-authenticator>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";

export default {

  name: 'SignIn',

  data () {

    return {

      form: {

        username: '',

        password: ''

      },

      configurationOptions:{

          signInConfig: {

          isSignUpDisplayed: false

        }

      }

    }

  },
  mounted() {
    this.$root.winHeight = window.innerHeight;
    if(this.$vuetify.breakpoint.xs || this.$root.winHeight<600){
      this.$router.push({ name: "Mobile" });
      this.screenlocked = true;
    }
    // console.log(this.$route);
    AmplifyEventBus.$on("authState", eventInfo => {
      // console.log("AUTHSTATE MOUNT: " + eventInfo);
      if (eventInfo === "signedIn") {
        this.$store.dispatch("updateEncountersInit");
        // // console.log(this.$route.query.redirect);
        // if(this.$route.query.redirect){
        //   this.$router.push(this.$route.query.redirect);
        // }else{
        //   this.$router.push({ name: "Home" });
        // }
      } else if (eventInfo === "signedOut") {
        this.$router.push({ name: "Auth" });
      }
    });
  },

  methods: {

    async signIn () {

      const { username, password } = this.form

      await this.$Auth.signIn(username, password)

      this.$AmplifyEventBus.$emit('authState', 'signedIn')

      //parent.signedIn = true

      //this.$router.push({ name: 'Home' })

    }

  }

}

</script>

<style>

.authButton {

  width: 100%;

  padding: 10px;

  margin-top: 10px;

  background-color: #2196f3;

  border: none;

  color: white;

  outline: none;

}

.auth {

  margin: 0 auto;

  width: 460px;

}

.centerMe {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
}

</style>